<rt-box
  variant="vertical"
  [rtProtectedControl]="locationsControl()"
  [class.invalid]="showInvalid && !readOnly()"
>
  <div
    layout
    layout-space-between
    [attr.margin-bottom]="locations.length || hasEmptyState() ? true : null"
  >
    <div>
      <rt-heading variant="heading large block">
        {{ translations.heading | translate }}
        @if (showRequired && !readOnly()) {
          <span class="badge-required">*</span>
        }
      </rt-heading>
      <span>
        {{ translations.subheading | translate }}
      </span>
    </div>
    @if (!readOnly()) {
      <rt-button variant="outline" (click)="!hasUpgradeIcon ? assignLocations() : openGuardModal()">
        <rt-icon name="add" />
        <div>{{ translations.assignLocation | translate }}</div>
        @if (hasUpgradeIcon) {
          <rt-icon size="small-x" name="upgrade" [colorToken]="colorToken" margin-left-small-xx />
        }
      </rt-button>
    }
  </div>

  <div
    [cdkDropListDisabled]="locations.length <= 1 || readOnly()"
    (cdkDropListDropped)="reorderLocations($event)"
    cdkDropList
    class="location-list"
    margin-top-small-xxx
  >
    @for (location of locations; track trackById($index, location); let isLast = $last) {
      <rt-location-item
        [location]="location"
        [hasManageLocationsAbility]="hasManageLocationsAbility"
        [readOnly]="readOnly()"
        [langCode]="currentLangCode()"
        [viewContext]="viewContext()"
        [attr.margin-bottom-small]="!isLast || null"
        (unassign)="unassignLocations(location.id)"
        (edit)="editLocation(location.id)"
        cdkDrag
        cdkDragLockAxis="y"
        cdkDragBoundary=".location-list"
      />
    }

    @if (!locations.length && hasEmptyState()) {
      <rt-empty-state
        [title]="translations.emptyState.title | translate"
        [desc]="translations.emptyState.description | translate"
        [minHeight]="true"
        icon="domain"
        variant="heading-large-x heading-margin-top-small v-centered"
      />
    }
  </div>
</rt-box>
@if (viewContext() === LocationsSectionViewContext.Job) {
  @if (showRequiredError) {
    <span text-red padding-top-small-xx>{{
      'app.offer_form.errors_new_validation.location.required' | translate
    }}</span>
  } @else if (showActiveLocationMissingError) {
    <span text-red padding-top-small-xx>{{
      'app.offer_form.errors_new_validation.location.no_active_location' | translate
    }}</span>
  } @else if (showExceededLocationLimitError) {
    <span text-red padding-top-small-xx>{{
      'app.offer_form.errors_new_validation.location.exceeded_location_limit'
        | translate: { number: locationsControl().value.length - locationsLimit }
    }}</span>
  }
}
